<template>
  <v-card>
    <v-card-text>
      {{$t('accessWithTokenDesc')}}
    </v-card-text>
  </v-card>
</template>

<script>

// Mixins
import mxLogin from '@/mixins/globals/mx-login'

export default {
  name: 'AccessWithToken',
  mixins: [mxLogin],

  props: {
    pToken: {
      type: String,
      required: true
    },
    pTienda: {
      type: String,
      required: false,
      default: 'n'
    }
  },

  mounted () {
    this.initApp()
  },

  methods: {
    initApp () {
      if (this.pToken !== '' && this.pToken !== null && this.pToken !== undefined) {
        this.tira = this.pToken
        localStorage.setItem('TiendaToken', (this.pTienda.toLowerCase() === 's'))
        if (localStorage.getItem('isOnPremise') === 'yes') {
          this.inicioSesionOnPremise(true)
        } else {
          this.inicioSesionDDOL(true)
        }
      }
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/views/AccessWithToken.vue